import { useLocation } from 'react-router-dom';
import WSA from '../WSA';
import ExternalRedirect from './ExternalRedirect';

const Signin: React.FC = () => {
  const location = useLocation();
  const redirectPath = location.state?.redirectTo;

  // Include redirect parameter in signin URL using returnState
  const signinUrl = redirectPath ? WSA.URLs.getSignin({ redirectTo: redirectPath }) : WSA.URLs.getSignin();

  return <ExternalRedirect externalUrl={signinUrl} shouldUseReplace />;
};
export default Signin;
